<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="COPYRIGHT">© 2014 Michael Brothers<br/>All rights reserved<br/><br/>Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /<br/>P.O. Box 163, Cambridge CB3 9PU U.K.<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">Brothers, Michael.<br/>Distance in preaching: room to speak, space to listen / Michael Brothers.<br/>pages   cm<br/>Includes bibliographical references and index.<br/>ISBN 978-0-8028-6969-2 (pbk.: alk. paper)<br/>eISBN 978-1-4674-4034-9 (ePub)<br/>eISBN 978-1-4674-3992-3 (Kindle)<br/>1. Preaching. 2. Listening — Religious aspects — Christianity. I. Title.<br/><br/>BV4211.3.B759 2014<br/>251 — dc23<br/>                          2014002439</p>
<p class="URL"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?ec557da2